import { ArrowRight, Play, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const features = ["28-day free trial", "No credit card required", "Cancel anytime"];

export const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="relative min-h-[100svh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-background via-background to-primary/5">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 md:w-96 h-64 md:h-96 bg-primary/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-64 md:w-96 h-64 md:h-96 bg-accent/10 rounded-full blur-3xl animate-pulse delay-1000" />
      </div>

      <div className="container mx-auto px-4 pt-16 md:pt-20 pb-12 md:pb-16 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="animate-hero-fade-in" style={{ animationDelay: "0ms" }}>
            <span className="inline-block px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-6">
              🚀 The Future of Travel Management
            </span>
          </div>

          <h1
            className="animate-hero-fade-in text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-4 md:mb-6"
            style={{ animationDelay: "100ms" }}
          >
            All-in-One Travel
            <span className="text-primary block mt-1 md:mt-2">Management Platform</span>
          </h1>

          <p
            className="animate-hero-fade-in text-base md:text-lg lg:text-xl text-muted-foreground mb-6 md:mb-8 max-w-2xl mx-auto"
            style={{ animationDelay: "200ms" }}
          >
            Streamline your travel business with 12 integrated modules. From CRM to AI-powered itineraries, 
            manage everything in one powerful platform.
          </p>

          <div
            className="animate-hero-fade-in flex flex-wrap justify-center gap-4 mb-8"
            style={{ animationDelay: "300ms" }}
          >
            {features.map((feature) => (
              <div
                key={feature}
                className="flex items-center gap-2 text-sm text-muted-foreground"
              >
                <CheckCircle2 className="w-4 h-4 text-primary" />
                {feature}
              </div>
            ))}
          </div>

          <div
            className="animate-hero-fade-in flex flex-col sm:flex-row gap-4 justify-center"
            style={{ animationDelay: "400ms" }}
          >
            <Button
              size="lg"
              className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-6 text-lg"
              onClick={() => window.open("https://tourbi.cloud/subscription", "_blank", "noopener,noreferrer")}
            >
              Start Free Trial
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-primary text-primary hover:bg-primary/10 px-8 py-6 text-lg"
              onClick={() => navigate("/demo")}
            >
              <Play className="mr-2 w-5 h-5" />
              Watch Demo
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
